<template>
  <ContentSearchEngineOptimization 
    v-if="currentCategory?.contextSensitiveData?.seoContent2"
    class="seo_content_2 overflow-x-auto p-4"
    :content="currentCategory.contextSensitiveData.seoContent2" />
</template>

<script setup lang="ts">
import type { NeoArticleCategoryView } from '@expert/types';

defineProps<{
  currentCategory: NeoArticleCategoryView;
}>();
</script>
